import { UseCaseError } from '@digibricks/core';

export class PaymentRequiredResultError<T> extends UseCaseError<T> {
  constructor(error?: string | Error) {
    super(error);
  }
}
